import React, { useState, useContext } from 'react';
import useAsyncEffect from 'use-async-effect';
import { useLocation } from 'hooks/router';
import Heading from 'components/common/heading/heading';
import Inputs from 'components/inputs/inputs';
import SystemStatusFilter from './systemStatusFilter';
import SystemStatusService from 'services/systemStatusService.js';
import transformSystemStatusFilters from './transformSystemStatusFilters';
import AppContext from 'contexts/appContext';
import StatusItem from './statusItem.js';
import './systemStatusPage.css';

export default function SystemStatusPage() {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const [filters, setFilters] = useState();
  const [results, setResults] = useState([]);
  const [resultsTop, setResultsTop] = useState([]);
  const location = useLocation();
  const [filterPopupVisible, setFilterPopupVisible] = useState(false);

  useAsyncEffect(async () => {
    setAppArea(AppContext.Areas.SystemStatus, 'System Status');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'System Status', selected: true }]);

    const useFilter = transformSystemStatusFilters(filters);
    const updates = await SystemStatusService.API.getSystemStatus(useFilter);
    setResults(updates);
    setResultsTop(updates.systemStatusesByGr);
  }, [location, filters]);

  const renderTop = (data) => {
    if (data && data.length === 0) {
      return <div>No data found.</div>;
    }
    return data && data.map((item) => SystemStatusTop(item));
  };

  const renderDiv = (data) => {
    if (data && data.length === 0) {
      return <div>No data found.</div>;
    }
    return data && data.map((item) => SystemStatusDiv(item));
  };

  function SystemStatusDiv(item) {
    return <StatusItem title={item.infoTypeDesc} value={item.infoValue} typeId={item.infoTypeId} status={item.status} created={item.created} to={'/SystemStatus/Details/' + item.infoTypeId} />;
  }

  function SystemStatusTop(item) {
    return (
      <div>
        <h4>{item.groupName}</h4>
        <hr />
        <div className='d-flex flex-wrap justify-content-center'>{renderDiv(item.systemStatuses)}</div>
      </div>
    );
  }

  return (
    <>
      <Heading>
        <div>
          <Inputs.Button variant='hover-default' onClick={() => setFilterPopupVisible(true)} iconClass='icons8-filter' label='Filter' />
        </div>
      </Heading>

      <div className='container mt-3'>
        {/*renderTop(resultsTop)*/}
      </div>

      <SystemStatusFilter
        filters={filters}
        show={filterPopupVisible}
        onClose={() => setFilterPopupVisible(false)}
        onChange={(filters) => {
          setFilters(filters);
          setFilterPopupVisible(false);
        }}
      />
    </>
  );
}
